.main {
  width: 640px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 0 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.main img.logo {
  padding: 40px 0;
  width: 396px;
  max-width: 100%;
  height: auto;
}

form {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

form label {
  font-size: var(--text-2xl);
  color: var(--secondary-color-gray800);
}

form input {
  font-size: var(--text-lg);
  font-weight: 400;
  line-height: 24px;
  padding: 16px 24px;
  width: 100%;
}

form input.alert {
  border: 2px solid rgb(218, 59, 59);
}

.email_error,
.nickname_error,
.pwd_error,
.pwd_cfm_error {
  color: var(--error-color);
  font-size: var(--text-lg);
  margin-top: -12px;
}

form input::placeholder {
  color: var(--secondary-color-gray400);
}

form input:focus {
  border: 1px solid var(--primary-color-100);
}

.pwd_container {
  position: relative;
}

.pwd_container img {
  position: absolute;
  top: 16px;
  right: 16px;
  bottom: 16px;
}

form button {
  width: 100%;
  height: 56px;
  border-radius: 9999px;
  font-size: var(--text-xl);
  font-weight: 600;
  background-color: var(--primary-color-100);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 0;
}

button:disabled {
  background-color: var(--secondary-color-gray400);
  color: white;
}

.oauth {
  width: 100%;
  height: 74px;
  padding: 0 23px;
  font-size: var(--text-lg);
  font-weight: 500;
  color: var(--secondary-color-gray800);
  background-color: var(--background-color-light-blue);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.oauth_images {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
}

.check_description {
  font-size: var(--text-lg);
  font-weight: 500;
}

.check_description a {
  color: #3182F6;
  font-weight: 500;
}

.popup_container {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  position: relative;
  font-size: var(--text-lg);
  font-weight: 500;
  background-color: white;
  color: var(--secondary-color-gray800);
  width: 540px;
  max-width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}

.popup_text {
  display: inline-block;
}

.popup_button_ok {
  display: inline-block;
  position: absolute;
  right: 28px;
  bottom: 28px;
  background-color: var(--primary-color-100);
  padding: 12px 23px;
  border-radius: 8px;
}

.popup_img {
	display: inline-block;
	width: 120px;
	height: 120px;
}

.none {
  display: none;
}
